/* @flow */

import * as React from 'react';
import colorUtils from 'color';
import glamorous from 'glamorous';
import { padding } from 'polished';

import { hover } from 'app/utils/cssUtils';
import Icon from './Icon';
import Tappable from './Tappable';

type Props = {
  className?: string,
  isFiltered: boolean,
  isOpen: boolean,
  onClear: () => void,
  onClick: () => void,
  maxWidth?: number,
  scheme?: 'light' | 'dark',
  text?: string
};

const defaultProps = {
  className: undefined,
  maxWidth: undefined,
  scheme: 'light',
  text: 'Filters'
};

const PlayerFilterButton = glamorous.div(
  {
    alignItems: 'center',
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'space-between',
    ...padding('0.375em', 10)
  },
  ({ highlight, scheme, theme }) =>
    highlight
      ? {
          backgroundColor: theme.color.primary,
          color: theme.color.white,
          ...hover({
            backgroundColor: colorUtils(theme.color.primary)
              .lighten(0.1)
              .string()
          })
        }
      : {
          color: scheme === 'light' ? theme.color.basis2 : theme.color.white,
          ...hover({
            backgroundColor: scheme === 'light' ? theme.color.white : theme.color.basis2
          })
        }
);

const Chevron = glamorous(Icon)(({ expanded }) => ({
  fontSize: '0.66em',
  marginLeft: 4,
  marginTop: -2,
  transform: expanded ? 'rotateZ(-90deg)' : 'rotateZ(90deg)',
  transformOrigin: 'center center',
  transition: 'transform 0.3s ease-out'
}));

const ClearFiltersButton = glamorous.span(
  ({ theme }) => ({
    paddingLeft: 8,
    color: theme.color.white,
    fontSize: '1.2em',
    ...hover({
      color: theme.color.basis2
    })
  }),
  'ion-close-circled'
);

const Text = glamorous.div(
  {
    ...padding('0.3em', 0),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  ({ maxWidth }) => ({
    maxWidth
  })
);

const RightSide = glamorous.div({
  display: 'flex',
  alignItems: 'center'
});

function FiltersToggleButton({
  className,
  isFiltered,
  isOpen,
  onClick,
  onClear,
  maxWidth,
  scheme,
  text
}: Props) {
  return (
    <Tappable
      component={PlayerFilterButton}
      className={className}
      highlight={isFiltered}
      onTap={onClick}
      isOpen={isOpen}
      scheme={scheme}
    >
      <Text maxWidth={maxWidth}>{text}</Text>
      <RightSide>
        <Chevron expanded={isOpen} type="icon-right-arrow" />
        {isFiltered && (
          <Tappable component={ClearFiltersButton} preventDefault stopPropagation onTap={onClear} />
        )}
      </RightSide>
    </Tappable>
  );
}

FiltersToggleButton.defaultProps = defaultProps;
export default FiltersToggleButton;
